module.exports = __webpack_public_path__ + "../resources/images/illustration_mention-d68b9580112fe0b77cf38fb70059eb7d.svg";